import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { GuestReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface GuestReadinessFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const GuestReadinessFilter: FC<GuestReadinessFilterProps> = props => {
  const guestReadinessOptions = Object.values(GuestReadinessStatus).map(readinessStatus => ({
    value: readinessStatus,
    hasFullWidth: true,
    label: humanizeString(readinessStatus),
  }))

  return <CheckboxBasedFilter title="Guest Readiness" options={guestReadinessOptions} {...props} />
}
